export const SFRTA_SwitchTestsAndInspectionsReportSections = {
  monthly: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 2,
    columns: [
      {
        title: "Monthly Tests",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 7,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Comments",
            colSpan: 10,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },
  quarterly: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 3,
    columns: [
      {
        title: "Quarterly Tests",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 7,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Comments",
            colSpan: 10,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },
  annually: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    minDataRowsCount: 3,
    columns: [
      {
        title: "Annual Tests",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Test Description & Rule",
            colSpan: 7,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "testDescription",
            dataClassName: "text-left pd-left-10px d-block",
          },
          {
            title: "Condition Left",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "summary.test",
          },
          {
            title: "Comments",
            colSpan: 10,
            rowSpan: 1,
            className: "tbl-text-normal",
            dataClassName: "text-left pd-left-10px d-block",
            accessor: "summary.com",
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/SwitchTestsAndInspectionsReport/SFRTA_SwitchTestsAndInspectionsReportSchema.js